


























import { Component, Prop, Vue } from "vue-property-decorator";
import { GameType, PurchasesType, UserType } from "@/types";
import Shop from "@/components/shop/Shop.vue";
import UserForm from "@/components/UserForm.vue";

@Component({ components: { Shop, UserForm } })
export default class Account extends Vue {
  @Prop({ required: false, default: null }) game!: GameType | null;
  @Prop({ required: false }) purchases?: PurchasesType;
  @Prop({ required: false, default: null }) user!: UserType | null;
}
